<template>
  <div style="padding:15px" class="containerTable">
    <vxe-toolbar
      id="toolbarId_fa3"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('diyReportReal_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('diyReportReal_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <template v-for="(item,index) in columnList">
        <vxe-table-column :key="'colimn'+index">
          <vxe-table-column
            :field="item.field"
            :title="item.fieldName"
            min-width="200"
          />
          <template
            v-if="item.type=='int'"
            v-slot:header
          >
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery[item.dbField+'_start']"
                  type="number"
                  placeholder="下限"
                  clearable
                  :disabled="item.source=='cal'"
                />
              </el-col>
              <el-col
                :span="11"
                :offset="2"
              >
                <el-input
                  v-model="listQuery[item.dbField+'_end']"
                  type="number"
                  placeholder="上限"
                  clearable
                  :disabled="item.source=='cal'"
                />
              </el-col>
            </el-row>
          </template>
          <template
            v-else-if="item.type=='date'"
            v-slot:header
          >
            <el-date-picker
              v-model="listQuery[item.dbField]"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, item.dbField)"
            />
          </template>
          <template
            v-else
            v-slot:header
          >
            <el-input
              v-model="listQuery[item.dbField]"
              :placeholder="item.fieldName"
              :disabled="item.source=='cal'"
              clearable
            />
          </template>
        </vxe-table-column>
      </template>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "DiyReport",
  components: {},
  data() {
    return {
      disabled:false,
      loading: false,
      columnList: [],
      tableData: [],
      exportObj:{
        exportUrl:"/ntocc-tms-api/diyReportField/exportDiyFieldReport",//导出接口
        name:'DIY报表'
      },
      listQuery: {
        code: "",
        branchCode: "",
        reportCode: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
    };
  },
  created() {
    this.findColumnList();
  },
  methods: {
    RefreshList(){
      this.listQuery = {
        code: "",
        branchCode: "",
        reportCode: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
      return this.findColumnList()
    },
    //查询自定义列表
    findColumnList() {
      this.loading = true;
      return new Promise(resolve => {
        this.listQuery.reportCode = this.$route.query.code;
        request({
          url: "/ntocc-tms-api/diyReportField",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.columnList = response.data.records;
          this.findList();
        }).catch(()=>{
          this.loading = false;
        });
        resolve();
      });
    },
    findList() {
      if (this.listQuery.hasOwnProperty("unload_quantity")) {
        if (this.listQuery.unload_quantity == "") {
          delete this.listQuery.unload_quantity;
        }
      }
      if (this.listQuery.hasOwnProperty("load_quantity")) {
        if (this.listQuery.load_quantity == "") {
          delete this.listQuery.load_quantity;
        }
      }
      this.loading = true;
      return new Promise(resolve => {
        //console.log(this.listQuery)
        request({
          url: "/ntocc-tms-api/diyReport/selectReport",
          method: "get",
          params: this.listQuery
        }).then(response => {
          //console.log(response)
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
        }).catch(()=>{
          //console.log('123');
          this.loading = false;
        });
        resolve();
      });
    },
     // 时间
      changeDate(value, prefix) {
        if (value) {
          this.listQuery[`${prefix}_start`] = value[0] + " 00:00:00";
          this.listQuery[`${prefix}_end`] = value[1] + " 23:59:59";
        }
        else {
          this.listQuery[`${prefix}_start`] = "";
          this.listQuery[`${prefix}_end`] = "";
        }
      },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    }
  }
};
</script>

<style>
</style>
